import React, { useState } from 'react';
import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem, Iconsvg, Tooltip, TooltipBody } from '@wk/components-react16';

const BatchTooltip = ({ data }: any) => {
    const placement: any = {
        offsets: {
            left: {
                leftOffset: 8,
            },
            'top-left': {
                leftOffset: 8,
            },
            right: {
                leftOffset: -8,
            },
            'top-right': {
                leftOffset: -8,
            }
        },
    };

    return (
        <div className='custom-modal'>
            <Tooltip
                identifier="tooltip-bottom-left"
                mode="interactive"
                position="bottom-left"
                targetSelector={"#button-top-right"+ data.id}
                placementOptions={placement}
                size='auto'
            >
                <TooltipBody slot="tooltipBody">
                    {data.validations.length > 0 ? data.validations.map((item: any, index: any) =>
                        item.isSelected && (
                        <div className={`mt-10 p-5 pt-2 pb-2 text-dark d-flex rounded bg-opacity-10 ${item.status ? 'bg-success' : 'bg-danger'}`} key={index}>
                            <div className='mr-10'>{item.name}</div>
                            <div className={`ms-auto text-${item.status ? 'success' : 'danger'}`}><Iconsvg size={12} name={item.status ? "check-circle" : "stop-sign"}></Iconsvg></div>
                        </div>
                        )
                    ) : null}
                </TooltipBody>
            </Tooltip>
        </div>
    );
};

export default BatchTooltip;